<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="row">
                <div class="col">
                  <h4 class="card-title">Lista de Localizadores</h4>
                  <p class="card-category">Detalle</p>
                </div>
              </div>
            </template>
            <l-table
              class="table-hover table-striped"
              :columns="table1.columns"
              :data="tags"
            >
            </l-table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LTable from "src/components/TableTag.vue";
import Card from "src/components/Cards/Card.vue";
import getSecret from "../helpers/get-secret";
const serverUrl = getSecret("SERVER_URL");
const tableColumns = ["Nombre"];
export default {
  components: {
    LTable,
    Card,
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem("jwt_licencia")).id_company,
      counter: JSON.parse(localStorage.getItem("jwt_licencia")).counter,
      tags: [],
      value1: "",
      value2: "",
      table1: {
        columns: [...tableColumns],
      },
    };
  },
  methods: {
    validateStatus() {
      this.axios
        .get(serverUrl + "/api/validateStatus/" + this.id_company)
        .then((res) => {
          if (res.data.info.licencia.status_commercial == "MORA") {
            window.localStorage.removeItem("jwt_user");
            window.localStorage.removeItem("jwt_licencia");
            window.localStorage.removeItem("jwt_token");
            location.href = location.origin + "/login";
          } else {
            let tipo = {
              name: res.data.info.licencia.name,
              id_company: res.data.info.licencia.id_company,
              payment_data: res.data.info.licencia.payment_data,
              status_commercial: res.data.info.licencia.status_commercial,
              counter: res.data.info.licencia.counter,
            };
            window.localStorage.setItem("jwt_licencia", JSON.stringify(tipo));
            if (this.counter != res.data.info.licencia.counter)
              location.reload();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dataTags() {
      this.tags.forEach((tag) => {
        tag.fecha_reporte = tag.last_report.slice(0, 16);
      });
    },
  },
  mounted() {
    this.$root.$on("send_tag", (data) => {
      this.tags = data;
      this.dataTags();
    });
    this.$root.$emit("getList");
    this.validateStatus();
  },
};
</script>
<style></style>
